/* SEARCH IN THE HEADER */

let search_inputs = document.querySelectorAll('.search-input');
let search_form = document.querySelector('.search-form');
let search_results = document.querySelector('.search-results');
let results_container = document.querySelector('.search-results__results-container');
let search_title = document.querySelector('.header__search-title');
let search_close_btns = document.querySelectorAll('.search-close');
let search_mobile_icon = document.querySelector('.header__icons-content.search-mobile');
let search_clear_btns = document.querySelectorAll('.search-clear-btn');
let body = document.querySelector('body');
let query;
let filters;
window.addEventListener("load", calculateHeaderHeight);
search_inputs.forEach(function (search_input) {
  // Click on the desktop search to open the search results
  search_input.addEventListener('click', openSearch);

  //Event on change on the search input
  let form = search_input.closest('.search-form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    refreshResults();
  });
  let timeout = null;
  search_input.addEventListener("input", function () {
    search_results.classList.add('loading');
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => {
      refreshResults();
    }, 600);

    //Display buttons to clear input value
    search_clear_btns.forEach(function (search_clear_btn) {
      if (search_input.value.length != 0) {
        // If search input as a value
        search_clear_btn.classList.add("active"); // Display clear button 
        search_results.classList.add("opacity"); // Change results background opacity 
      } else {
        // If search input is empty
        search_clear_btn.classList.remove("active"); // Hide clear button
        search_results.classList.remove("opacity"); // Change results background opacity
        results_container.innerHTML = "";
      }
    });
  });
  search_clear_btns.forEach(function (search_clear_btn) {
    search_clear_btn.addEventListener('click', function () {
      // Clear value into search input
      search_input.value = ""; // Empty search input
      search_clear_btn.classList.remove('active'); // Hide clear btns
      search_results.classList.remove('opacity'); // Change search results background opacity

      refreshResults();
    });
  });
  search_close_btns.forEach(function (search_close_btn) {
    // Close search with close button
    search_close_btn.addEventListener("click", closeSearch);
  });
});

// Click on the mobile search to open the search results
search_mobile_icon.addEventListener('click', function () {
  search_results.classList.add('active'); // Show search results container
  body.classList.add('no-scroll'); // Desactivate body scroll
});

// Close search results 
search_close_btns.forEach(function (search_close_btn) {
  search_close_btn.addEventListener('click', function () {
    search_results.classList.remove('active'); // Hide search results
    body.classList.remove('no-scroll'); // Reactivate body scroll
  });
});

// Check if announcement bar is enabled and ajust top position of the search drawer
let announcement_bar = document.querySelector('.announcement-bar');
if (announcement_bar != undefined) {
  // If announcement bar is enabled
  search_results.classList.add('with-announcement-bar'); // search results top = 125px
} else {
  // If announcement bar isn't enabled
  search_results.classList.add('without-announcement-bar'); // search results top = 85px
}

document.addEventListener('scroll', calculateHeaderHeight);

// FUNCTIONS

function openSearch() {
  search_results.classList.add('active');
  search_title.classList.add('active');
  search_close_btns.forEach(function (search_close_btn) {
    search_close_btn.classList.add('active');
  });
  body.classList.add('no-scroll');
}
function closeSearch() {
  search_results.classList.remove("active"); // Hide search results
  search_title.classList.remove("active"); // Hide search title
  //search_close_btn.classList.remove("active"); // Hide search close button
  body.classList.remove("no-scroll"); // Reactivate body scroll

  search_clear_btns.forEach(function (search_clear_btn) {
    search_clear_btn.classList.remove("active"); // Hide clear btn
  });

  search_close_btns.forEach(function (search_close_btn) {
    search_close_btn.classList.remove("active"); // Hide close btn
  });

  search_inputs.forEach(function (search_input) {
    search_input.value = ""; // Empty the field
  });

  refreshResults();
}
function calculateHeaderHeight() {
  let root = document.documentElement;
  let announcementHeight = document.querySelector('#shopify-section-announcement-bar').offsetHeight;
  let headerHeight = document.querySelector('#shopify-section-header').offsetHeight;
  if (window.scrollY > announcementHeight) {
    root.style.setProperty('--header-height', headerHeight + 'px');
  } else {
    root.style.setProperty('--header-height', announcementHeight + headerHeight - window.scrollY + 'px');
  }
}
function initFilters() {
  let applyFilters = document.querySelector('.search-results #btn-apply-filters');
  let activeFilters = document.querySelectorAll('.active-facets__item');
  let clearAll = document.querySelector('.mobile-facets__clear-all');
  let closeDrawer = document.querySelector('.mobile-facets__close-drawer');
  var priceRange = document.querySelector('.mobile-facets__price-range');
  applyFilters.addEventListener('click', function (e) {
    e.preventDefault();
    refreshResults();
  });
  activeFilters.forEach(function (filter) {
    filter.addEventListener('click', function () {
      let filterName = filter.getAttribute('data-filter-name');
      let filterValue = filter.getAttribute('data-filter-value');
      filter.remove();
      let matchingFilter = document.querySelector(`.search-results input[name="${filterName}"][value="${filterValue}"]`);
      matchingFilter.checked = false;
    });
  });
  if (clearAll !== null) {
    clearAll.addEventListener('click', function () {
      document.querySelector('.mobile-facets__disclosure').classList.remove('menu-opening');
      refreshResults("");
    });
  }
  closeDrawer.addEventListener('click', function () {
    document.querySelector('.mobile-facets__open-wrapper').click();
  });

  // Price range filter
  let minPrice = parseInt(priceRange.getAttribute('data-min'));
  let maxPrice = parseInt(priceRange.getAttribute('data-max'));
  let currentMinPrice = parseInt(priceRange.getAttribute('data-current-min'));
  let currentMaxPrice = parseInt(priceRange.getAttribute('data-current-max'));
  noUiSlider.create(priceRange, {
    start: [currentMinPrice, currentMaxPrice],
    connect: true,
    margin: 10,
    range: {
      'min': minPrice,
      'max': maxPrice
    },
    step: 10
  });
  priceRange.noUiSlider.on('slide', function () {
    let minValue = Math.round(priceRange.noUiSlider.get()[0]);
    let maxValue = Math.round(priceRange.noUiSlider.get()[1]);
    document.querySelector('.mobile-facets__price-min').innerHTML = minValue;
    document.querySelector('.mobile-facets__price-max').innerHTML = maxValue;
    document.querySelector('.mobile-facets__price-min-input').value = minValue;
    document.querySelector('.mobile-facets__price-max-input').value = maxValue;
  });
}
function refreshResults(filters = null) {
  search_results.classList.add('loading');
  let filtersForm = document.querySelector('.search-results #FacetFiltersFormMobile');

  // Get filters params
  if (filters == null && filtersForm !== null) {
    let filtersFormData = new FormData(filtersForm);
    filtersFormData.delete('q');
    filters = new URLSearchParams(filtersFormData).toString();

    /* console.log('filters : ', ...filtersFormData) */
  }

  // Get search query
  if (window.matchMedia("(min-width: 960px").matches) {
    query = document.querySelector('.search-input--desktop').value;
  } else {
    query = document.querySelector('.search-input--mobile').value;
  }

  /* console.log('query : ', query);
  console.log('filters : ', filters) */

  let url = window.Shopify.routes.root + 'search?q=' + query + '&' + (filters !== null ? filters : '');
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    //return response.json();
    response.text().then(text => {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var html = parser.parseFromString(text, 'text/html');

      // Render the search section from the search page DOM
      results_container.innerHTML = html.querySelector('.main-search-section').outerHTML;
      if (query.length > 0 && document.querySelector('.search-results .mobile-facets') !== null) {
        initFilters();
      }
      search_results.classList.remove('loading');
    });
    //console.log(response.json());
  }).catch(error => {
    console.error('Error:', error);
    search_results.classList.remove('loading');
  });
}